import { Flex, Popover, Space } from 'antd'
import StampImageLink from '../../../../components/stamp-image-link/stamp-image-link'
import { ColumnType } from 'antd/es/table'
import StampOrder from '../../../../types/api/stamp-order'
import Edit from '../components/table/edit'
import Reorder from '../components/table/reorder'
import { Link } from 'react-router-dom'
import { dynamicRoutes } from '../../../../constants/routes'
import UserCell from '../../../../components/user-cell/user-cell'
import renderDatetime from '../../../../helpers/tables/render-datetime'
import renderDate from '../../../../helpers/tables/render-date'
import StampOrderOrderStatusCell from '../components/stamp-order-order-status-cell/stamp-order-order-status-cell'
import renderStampOrderUrgent from '../../../../helpers/tables/render-stamp-order-urgent'

export const columns: ColumnType<StampOrder>[] = [
    {
        dataIndex: 'id',
        title: 'Номер',
        width: 100,
    },
    {
        dataIndex: 'stamp',
        title: 'Штамп',
        width: 150,
        render(value, record, index) {
            const { stamp } = record
            if (!stamp) return ''

            return (
                <Flex justify={'space-between'}>
                    <Popover
                        placement={'rightTop'}
                        content={
                            <>
                                <p>тут могут быть характеристики штампа</p>
                            </>
                        }
                    >
                        <Link to={dynamicRoutes.equipmentStamp(stamp?.documentId || '')}>
                            {stamp.number || '—'}
                        </Link>
                    </Popover>
                    <StampImageLink stamp={stamp} layout />
                </Flex>
            )
        },
    },
    {
        dataIndex: 'createdAt',
        title: 'Дата создания',
        width: 160,
        render: renderDate,
    },
    {
        dataIndex: 'estimatedDate',
        title: 'Дата поставки',
        width: 160,
        render: v => (v ? renderDatetime(v) : ''),
    },
    {
        dataIndex: 'orderStatus',
        title: 'Статус',
        width: 140,
        render: (orderStatus: StampOrder['orderStatus']) => (
            <StampOrderOrderStatusCell orderStatus={orderStatus} />
        ),
    },
    {
        dataIndex: ['initiator', 'username'],
        title: 'Менеджер',
        width: 140,
        render(value, record, index) {
            return <UserCell username={value} />
        },
    },
    {
        dataIndex: 'urgent',
        title: 'Срочно',
        width: 70,
        align: 'center',
        render: renderStampOrderUrgent,
    },
    {
        dataIndex: 'price',
        title: 'Цена',
        width: 140,
    },
    {
        dataIndex: 'comment',
        title: 'Примечание',
        width: 140,
    },
    {
        dataIndex: '1',
        title: 'Действия',
        fixed: 'right',
        // width: 100, // without compact
        width: 80,
        render: (_, record: StampOrder) => {
            return (
                <Space>
                    <Edit stampOrderDocId={record.documentId} />
                    <Reorder stampOrderDocId={record.documentId} />
                </Space>
            )
        },
    },
]
